// https://codepen.io/lychanhdarit/pen/xaYomE


var StreetsOfZofingen = [
	{ title: "Aarburgerstrasse" },
	{ title: "Ackerstrasse" },
	{ title: "Aeppenhaldenstrasse" },
	{ title: "Aeschwuhrstrasse" },
	{ title: "Ahornweg" },
	{ title: "Alpenblickweg" },
	{ title: "Altachenstrasse" },
	{ title: "Alter Kirchweg" },
	{ title: "Am Hubersbergli" },
	{ title: "Am Naglerbach" },
	{ title: "Am Rain" },
	{ title: "Am Stadtbach" },
	{ title: "Bachgasse" },
	{ title: "Bahnhofplatz" },
	{ title: "Bahnweg" },
	{ title: "Bärengasse" },
	{ title: "Bärenhubelstrasse" },
	{ title: "Berghaldenstrasse" },
	{ title: "Besenmattweg" },
	{ title: "Bifangstrasse" },
	{ title: "Birkenweg" },
	{ title: "Bleicheweg" },
	{ title: "Blumengasse" },
	{ title: "Blustweg" },
	{ title: "Bornweg" },
	{ title: "Bottensteinerstrasse" },
	{ title: "Bottenwilerstrasse" },
	{ title: "Brittnauerstrasse" },
	{ title: "Brotweg" },
	{ title: "Brühlgässli" },
	{ title: "Brühlmatten" },
	{ title: "Brühlstrasse" },
	{ title: "Brühlweg" },
	{ title: "Brunnhaldenweg" },
	{ title: "Brunngrabenweg" },
	{ title: "Buchmattweg" },
	{ title: "Bündtengasse" },
	{ title: "Buschgutweg" },
	{ title: "Chorgasse" },
	{ title: "Dorfbachstrasse" },
	{ title: "Eigerweg" },
	{ title: "Eisengrubenweg" },
	{ title: "Engelgasse" },
	{ title: "Erikaweg" },
	{ title: "Erlenweg" },
	{ title: "Eschenweg" },
	{ title: "Färbereiweg" },
	{ title: "Farbgasse" },
	{ title: "Fegergasse" },
	{ title: "Finkenherdstrasse" },
	{ title: "Finkenrain" },
	{ title: "Fischerstrasse" },
	{ title: "Fliederstrasse" },
	{ title: "Florastrasse" },
	{ title: "Forstackerstrasse" },
	{ title: "Frikartstrasse" },
	{ title: "Frohburgstrasse" },
	{ title: "Funkenstrasse" },
	{ title: "Gasstrasse" },
	{ title: "Galgenweg" },
	{ title: "General-Guisan-Strasse" },
	{ title: "Gerbergasse" },
	{ title: "Gigerhalde" },
	{ title: "Gottfried-Keller-Strasse" },
	{ title: "Gotthelfstrasse" },
	{ title: "Grenzstrasse" },
	{ title: "Hägelerstrasse" },
	{ title: "Haldenweg" },
	{ title: "Hardeckweg" },
	{ title: "Hardstrasse" },
	{ title: "Haselweg" },
	{ title: "Hauptstrasse" },
	{ title: "Haurihäuserweg" },
	{ title: "Heiternplatzweg" },
	{ title: "Hechtgasse" },
	{ title: "Henzmannstrasse" },
	{ title: "Hintere Hauptgasse" },
	{ title: "Hirschparkweg" },
	{ title: "Hirzenbergstrasse" },
	{ title: "Höfenstrasse" },
	{ title: "Hottigergasse" },
	{ title: "Im Brühl" },
	{ title: "Im Buschgut" },
	{ title: "Im Einschlag" },
	{ title: "Im Rank" },
	{ title: "Im Römerquartier" },
	{ title: "Im Schürli" },
	{ title: "Im Stöckliacker" },
	{ title: "Industriestrasse" },
	{ title: "Innere Altachen" },
	{ title: "Jägerweg" },
	{ title: "Junkerbifangstrasse" },
	{ title: "Junkermattstrasse" },
	{ title: "Jurastrasse" },
	{ title: "Kanalweg" },
	{ title: "Kanzleigässli" },
	{ title: "Kilchbergstrasse" },
	{ title: "Kirchgasse" },
	{ title: "Kirchmooshöhe" },
	{ title: "Kirchmoosstrasse" },
	{ title: "Kirchplatz" },
	{ title: "Kläranlageweg" },
	{ title: "Klösterligasse" },
	{ title: "Kornweg" },
	{ title: "Kronengasse" },
	{ title: "Küngoldingerstrasse" },
	{ title: "Kunzenbadstrasse" },
	{ title: "Lateingasse" },
	{ title: "Lerchenweg" },
	{ title: "Letzigasse" },
	{ title: "Lindenplatz" },
	{ title: "Luzernerstrasse" },
	{ title: "Malergässli" },
	{ title: "Marktgasse" },
	{ title: "Meienweg" },
	{ title: "Mohrenacherstrasse" },
	{ title: "Mühlegasse" },
	{ title: "Mühlemattstrasse" },
	{ title: "Mühlethalstrasse" },
	{ title: "Müllerweg" },
	{ title: "Napfweg" },
	{ title: "Nationalbahnweg" },
	{ title: "Niklaus-Thut-Platz" },
	{ title: "Nussweg" },
	{ title: "Obere Brühlstrasse" },
	{ title: "Obere Mühlemattstrasse" },
	{ title: "Obere Promenade" },
	{ title: "Obere Rebbergstrasse" },
	{ title: "Ochsengasse" },
	{ title: "Pappelweg" },
	{ title: "Petschirgässli" },
	{ title: "Pestalozziweg" },
	{ title: "Pfistergasse" },
	{ title: "Philosophenweg" },
	{ title: "Pilatusweg" },
	{ title: "Pomerngut" },
	{ title: "Pomernhalde" },
	{ title: "Pomernweg" },
	{ title: "Rabengasse" },
	{ title: "Rathausgasse" },
	{ title: "Rebbergstrasse" },
	{ title: "Reutenstrasse" },
	{ title: "Riedhalde" },
	{ title: "Riedtalstrasse" },
	{ title: "Riedweg" },
	{ title: "Rigiweg" },
	{ title: "Ringmauergasse" },
	{ title: "Roggenweg" },
	{ title: "Römerbadweg" },
	{ title: "Römerhalde" },
	{ title: "Römerweg" },
	{ title: "Röseliweg" },
	{ title: "Rosengartenstrasse" },
	{ title: "Rosmaringasse" },
	{ title: "Rösslimattstrasse" },
	{ title: "Rotfarbstrasse" },
	{ title: "Rüsseckstrasse" },
	{ title: "Sälistrasse" },
	{ title: "Schafgasse" },
	{ title: "Schattengässli" },
	{ title: "Schifflände" },
	{ title: "Schleifeweg" },
	{ title: "Schlossbaanweg" },
	{ title: "Schmiedgasse" },
	{ title: "Schulgasse" },
	{ title: "Schulhausstrasse" },
	{ title: "Schützenstrasse" },
	{ title: "Seilergasse" },
	{ title: "Sonnenrain" },
	{ title: "Sonnenweg" },
	{ title: "Spitalgasse" },
	{ title: "Sternengasse" },
	{ title: "Stiftshalde" },
	{ title: "Stöckliackerweg" },
	{ title: "Storchengasse" },
	{ title: "Strengelbacherstrasse" },
	{ title: "Stüdlerweg" },
	{ title: "Südstrasse" },
	{ title: "Trottenrain" },
	{ title: "Ulmenweg" },
	{ title: "Untere Brühlstrasse" },
	{ title: "Untere Grabenstrasse" },
	{ title: "Vordere Hauptgasse" },
	{ title: "Vreneliweg" },
	{ title: "Wässermattenweg" },
	{ title: "Weidstrasse" },
	{ title: "Weiherstrasse" },
	{ title: "Weissensteinstrasse" },
	{ title: "Weststrasse" },
	{ title: "Wiesenstrasse" },
	{ title: "Wiggerweg" },
	{ title: "Wuhrmattstrasse" },
	{ title: "Wydenweg" },
	{ title: "Zelglistrasse" }
];

var searchFormNode = document.querySelector('#addressLookup');
var searchInputNode = document.querySelector('#streetname');
var autoCompleteNode = document.querySelector('.search-auto-complete');
var resultNode = document.querySelector('#contact-form-street');


var input = '';
var results = [];
var selected = -1;
var showAutoComplete = false;


var fuse = new Fuse(
	StreetsOfZofingen,
	{
	  keys: ['title'],
	  shouldSort: true,
	  threshold: 0.5,
	  maxPatternLength: 50 }
	  );

	  function renderAutoComplete() {
		if (!showAutoComplete || input.length < 3 || results.length === 0) {
		  autoCompleteNode.classList.remove('block');
		  autoCompleteNode.classList.add('hidden');
		  return '';
		} else {
			autoCompleteNode.classList.remove('hidden');
			autoCompleteNode.classList.add('block');
		}
	  
		return "\n    <ul>\n      " +
	  
		results.map(function (result, index) {return "\n        <li x-on:click='address.streetname = \"" +result.title+ "\"' class='px-6 cursor-pointer auto-complete-item py-2 hover:bg-base-100" + (
		  index === selected ? ' selected' : '') + "'>\n          " +
		  result.title + "\n        </li>\n      ";}).
	  
		join('') + "\n    </ul>\n  ";
	  
	  
	  }
	  
	  function handleSearchSubmit(event) {
		if (event) {
		  event.preventDefault();
		}
	  
		input = searchInputNode.value.trim();
		selected = -1;
	  
		document.activeElement.blur();
		autoCompleteNode.innerHTML = renderAutoComplete();
		resultNode.value = input;
	  }
	  
	  function handleSearchInput(event) {
		input = event.target.value;
		results = [];
		if (input.length >= 3) {
		  results = fuse.search(input).slice(0, 7);
		}
		showAutoComplete = true;
		autoCompleteNode.innerHTML = renderAutoComplete();
		resultNode.value = input;
	  }
	  
	  function updateSearchInput() {
		if (selected === -1) {
		  searchInputNode.value = input;
		} else {
		  searchInputNode.value = results[selected].title;
		   // dc - Updates Alpine value on KeyArrow selection
		   let evt = new CustomEvent("address-value-changed", {detail: results[selected].title });
		   window.dispatchEvent(evt);
		}
		autoCompleteNode.innerHTML = renderAutoComplete();
	  }
	  
	  function handleSearchKeyDown(event) {
		switch (event.which) {
		  case 38: // Arrow up
			selected = Math.max(--selected, -1);
			updateSearchInput();
			resultNode.value = input;
			break;
		  case 40: // Arrow down
			selected = Math.min(++selected, results.length - 1);
			showAutoComplete = true;
			updateSearchInput();
			resultNode.value = input;
			break;
		  case 9: // Tab
			showAutoComplete = false;
			updateSearchInput();
			resultNode.value = input;
			break;
		  case 27: // Escape
			selected = -1;
			showAutoComplete = false;
			updateSearchInput();
			resultNode.value = input;
			break;}
	  
	  }
	  
	  function handleAutoCompleteClick(event) {
		event.stopPropagation(); // Prevent click from bubbling to window click handler
		searchInputNode.value = event.target.textContent.trim();
		showAutoComplete = false;
		handleSearchSubmit();
	  }
	  
	  function handleWindowClick(event) {
		showAutoComplete = false;
		autoCompleteNode.innerHTML = renderAutoComplete();
	  }
	  
	  searchFormNode.addEventListener('submit', handleSearchSubmit);
	  document.querySelector('.streetname-container').addEventListener('keydown', handleSearchKeyDown);
	  searchInputNode.addEventListener('input', handleSearchInput);
	  autoCompleteNode.addEventListener('click', handleAutoCompleteClick);
	  window.addEventListener('click', handleWindowClick);